// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Column_wrapper__jRa4W","columns":"Column_columns__PBM6w","column":"Column_column__ykdTR","legend":"Column_legend__pP9a3"};